import dynamic from "next/dynamic";

import { getBaseURL } from "_common/utils";
import ActionButton   from "_components/molecules/mobileFeedActionButton";

import useStyles from "./styles";

const SharePopper = dynamic ( () => import ( "_components/molecules/sharePopper" ) );

const component = ( {
	showShareDrawer,
	setShowShareDrawer,
	openChat,
	feedId,
	isReacted,
	setChatContainerTabName,
	isLeaderBoardLive,
	onClickLikeBtn
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<SharePopper
				useModal
				getSrc      = { () => getBaseURL () + `/stream/${ feedId }` }
				handleClose = { () => setShowShareDrawer ( false ) }
				open        = { showShareDrawer }
			/>

			<div className = { classes.container }>
				<ActionButton
					activeIconName = "heartFilled"
					iconName       = "heart"
					isActive       = { isReacted }
					onClick        = { onClickLikeBtn }
					title          = { "Like" }
				/>

				<ActionButton
					iconName = "liveChat"
					onClick  = { openChat }
					title    = { "Live Chat" }
				/>

				<ActionButton
					iconName = "share"
					onClick  = { () => setShowShareDrawer ( true ) }
					title    = { "Share" }
				/>

				{
					isLeaderBoardLive ? (
						<ActionButton
							iconName = "fanrank"
							onClick  = { () => {
								setChatContainerTabName ( "fanrank" );
								openChat ();
							} }
							title    = { "Fan Rank" }
						/>
					) : null
				}

				<ActionButton
					iconName = "donation"
					onClick  = { () => {
						setChatContainerTabName ( "donation" );
						openChat ();
					} }
					title    = { "Top Donors" }
				/>

			</div>
		</>
	);
};

export default component;

